const $ = jQuery.noConflict();
import Global from '../shared/global';

'use strict';
const Popups = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domBody: $('body'),
	$domTestimonialBlockPopupTrigger: $('.js-testimonial-slider__box-read'),
	$domTestimonialPopupPopup: $('.js-testimonial-popup'),
	$domTestimonialPopupInner: $('.js-testimonial-popup__inner'),
	$domSliderPopupTrigger: $('.js-slider-bottom__box-read'),
	$domSliderPopupPopup: $('.js-slider-popup'),
	$domSliderPopupInner: $('.js-slider-popup__inner'),
	$domSliderIconClose: $('.js-slider-popup__box-close-icon'),
	$domContactPopup: $('.cf7-holder__popup'),
	$domContactInnerPopup: $('.contact-us__popup-inner'),
	$domContactBtnIcon: $('.contact-us__popup-icon'),
	$domCartPopupPopup: $('.js-cart-popup'),
	$domCartPopupInner: $('.js-cart-popup__inner'),
	$domCartPopupCloseIcon: $('.js-cart-popup__inner-close'),
	$domCustomOrderPopupTrigger: $('.js-single-product__slider-upper-link'),
	$domCustomOrderPopupPopup: $('.js-custom-order__popup'),
	$domCustomOrderPopupInner: $('.js-custom-order__popup-inner'),
	$domCustomOrderIconClose: $('.js-custom-order__popup-close-icon'),
	$domCartRemovePopupTrigger: '.js-product-remove',
	$domCartRemovePopupPopup: '.js-cart-remove__popup',
	$domCartRemovePopupInner: '.js-cart-remove__popup-inner',
	$domCartRemoveIconClose: '.js-cart-remove__popup-close-icon',
	$domCartRemoveBtnClose: '.js-remove__popup-btn-alt',
	$domAddressRemovePopupTrigger: $('.wc-address-book-delete'),
	$domAddressRemovePopupPopup: $('.js-address-remove__popup'),
	$domAddressRemovePopupInner: $('.js-address-remove__popup-inner'),
	$domAddressRemoveIconClose: $('.js-address-remove__popup-close-icon'),
	$domAddressRemoveBtnClose: $('.js-remove__popup-btn-alt-address'),
	$domOrderCancelButton: $('.js-order-Cancel'),
	$domOrderCancelPopupPopup: $('.js-my-account__order-cancel-popup'),
	$domOrderCancelPopupInner: $('.js-my-account__order-cancel-popup-inner'),
	$domOrderCancelCloseIcon: $('.js-my-account__order-cancel-popup-icon'),
	$domOrderCancelCloseBtn: $('.js-my-account__order-cancel-btn'),
	$domPaymentRemovePopupPopup: $('.js-my-account__payments-remove-popup'),
	$domPaymentRemovePopupInner: $('.js-my-account__payments-remove-popup-inner'),
	$domPaymentRemoveIconClose: $('.js-my-account__payments-remove-popup-close-icon'),
	$domPaymentRemoveBtnClose: $('.js-remove__popup-btn-alt-payment'),
	$domPaymentRemoveTrigger: $('.js-payment-delete'),
	// $domNewYearPromoCodePopup: $('.js-popup-newyear'),
	// $domNewYearPromoCodePopupInner: $('.js-popup-newyear__inner'),
	// $domNewYearPromoCodeIconClose: $('.js-popup-newyear__close-icon'),
	classActive: 'is-active',
	classPreventScroll: 'prevent-scroller',
	classPreventScrollAlt: 'prevent-scroller-alt',

	/** @description Initialize */
	init: function() {
		this.testimonialPopupShow();
		this.closeMenuOnOusideContainerClickTestimonial();
		Global.escKey(Popups.closeTestimonialPopup);
		this.sliderPopupShow();
		this.closeSliderOnIcon();
		this.closeMenuOnOusideContainerClickSlider();
		Global.escKey(Popups.closeSliderPopup);
		this.closeContactPopupIcon();
		this.closeMenuOnOusideContainerClickContact();
		Global.escKey(Popups.closeContactPopup);
		this.closeCartPopupIcon();
		this.closeMenuOnOusideContainerClickCartPopup();
		Global.escKey(Popups.closeCartPopup);
		this.customOrderPopupShow();
		this.closeCustomOrderOnIcon();
		// this.closeMenuOnOusideContainerClickCustomOrder();
		Global.escKey(Popups.closeCustomOrderPopup);
		this.cartRemovePopupShow();
		this.closeCartRemovePopupOnIcon();
		this.closeCartRemovePopupOnBtn();
		this.closeMenuOnOusideContainerClickCartRemovePopup();
		Global.escKey(Popups.closeCartRemovePopup);
		this.openOrderCancelPopup();
		this.closeOrderCancelPopupIcon();
		this.closeOrderCancelPopupBtn();
		this.closeMenuOnOusideContainerClickOrderCancelPopup();
		Global.escKey(Popups.closeOrderCancelPopup);
		this.addressRemovePopupShow();
		this.closeAddressRemovePopupOnIcon();
		this.closeAddressRemovePopupOnBtn();
		this.closeMenuOnOusideContainerClickAddressRemovePopup();
		Global.escKey(Popups.closeAddressRemovePopup);
		this.closePaymentRemovePopupOnIcon();
		this.closePaymentRemovePopupOnBtn();
		this.closeMenuOnOusideContainerClickPaymentRemovePopup();
		this.openPaymentRemovePopup();
		Global.escKey(Popups.closePaymentRemovePopup);
		this.popupNewYearPromoCode();
		// this.openPopupNewYearPromoCode();
		// this.closepopupNewYearPromoCodeOnIcon();
		// this.closeMenuOnOusideContainerClickPopupNewYearPromoCode();
		// Global.escKey(Popups.closepopupNewYearPromoCode);
	},

	// preventScroll: () => {
	// 	if(window.innerWidth < 1200) {
	// 		$('.body').on('touchmove', function(e) {
	// 			e.preventDefault();
	// 		});
	// 	}
	// },

	testimonialPopupShow: function() {
		$('.js-testimonial-slider__box-read').each(function(i, el) {
			$(el).on('click', function() {
				const popupNum = $(el).data('popup');
				Popups.$domBody.addClass(Popups.classPreventScroll);
				$(`.js-testimonial-popup-${popupNum}`).addClass(Popups.classActive);
			});
		});
	},

	closeTestimonialPopup: function() {
		Popups.$domBody.removeClass(Popups.classPreventScroll);
		Popups.$domTestimonialPopupPopup.removeClass(Popups.classActive);
	},

	/* @description close menu if click outside container */
	closeMenuOnOusideContainerClickTestimonial: function() {
		Popups.$domBody.on('mouseup', function(e) {
			e.preventDefault();
			if (Popups.$domTestimonialPopupPopup.hasClass(Popups.classActive) && !Popups.$domTestimonialPopupInner.is(e.target) && Popups.$domTestimonialPopupInner.has(e.target).length === 0) {
				Popups.closeTestimonialPopup();
			}
		});
	},

	sliderPopupShow: function() {
		$('.js-slider-bottom__box-read').each(function(i, el) {
			$(el).on('click', function() {
				const popupNum = $(el).data('popup');
				Popups.$domBody.addClass(Popups.classPreventScroll);
				$(`.js-slider-popup-${popupNum}`).addClass(Popups.classActive);
			});
		});
	},

	closeSliderOnIcon: function() {
		Popups.$domSliderIconClose.on('click', function() {
			Popups.closeSliderPopup();
		});
	},

	closeSliderPopup: function() {
		Popups.$domBody.removeClass(Popups.classPreventScroll);
		Popups.$domSliderPopupPopup.removeClass(Popups.classActive);
	},

	/* @description close menu if click outside container */
	closeMenuOnOusideContainerClickSlider: function() {
		Popups.$domBody.on('mouseup', function(e) {
			e.preventDefault();
			if (Popups.$domSliderPopupPopup.hasClass(Popups.classActive) && !Popups.$domSliderPopupInner.is(e.target) && Popups.$domSliderPopupInner.has(e.target).length === 0 && !Popups.$domSliderIconClose.is(e.target)) {
				Popups.closeSliderPopup();
			}
		});
	},

	closeContactPopup: function() {
		Popups.$domBody.removeClass('prevent-scroller');
		Popups.$domContactPopup.removeClass(Popups.classActive);
	},

	closeContactPopupIcon: function() {
		Popups.$domContactBtnIcon.on('click', function() {
			Popups.closeContactPopup();
		});
	},

	closeMenuOnOusideContainerClickContact: function() {
		Global.$domBody.on('mouseup', function(e) {
			e.preventDefault();
			if (Popups.$domContactPopup.hasClass(Popups.classActive) && !Popups.$domContactInnerPopup.is(e.target) && Popups.$domContactInnerPopup.has(e.target).length === 0 && !Popups.$domContactBtnIcon.is(e.target)) {
				Popups.closeContactPopup();
			}
		});
	},

	addToCartPopup: function(html) {
		$('.js-cart-popup-list').append(html);
		Popups.$domCartPopupPopup.toggleClass(Popups.classActive);
		Popups.$domBody.addClass(Popups.classPreventScrollAlt);
		Popups.$domCartPopupPopup.on('touchmove', function(e) {
			e.preventDefault();
		});
	},

	addProductToCartPopup: function(image, text) {
		const template = '<div class="cart-popup__box">\n' +
			'\t\t\t\t<div class="cart-popup__box-image">\n' +
			'\t\t\t\t\t<img class="cart-popup__box-img" src="{image}" alt="Product Image">\n' +
			'\t\t\t\t</div>\n' +
			'\t\t\t\t<span class="cart-popup__box-text">{text}</span>\n' +
			'\t\t\t</div>';
		const html = template.replace('{image}', image).replace('{text}', text);
		Popups.addToCartPopup(html);
		setTimeout(function(){
			Popups.$domCartPopupPopup.removeClass(Popups.classActive);
			Popups.$domBody.removeClass(Popups.classPreventScrollAlt);
		}, 10000);
	},

	closeCartPopup: function() {
		Popups.$domCartPopupPopup.removeClass(Popups.classActive);
		Popups.$domBody.removeClass(Popups.classPreventScrollAlt);
	},

	closeCartPopupIcon: function() {
		Popups.$domCartPopupCloseIcon.on('click', function() {
			Popups.closeCartPopup();
		});
	},

	closeMenuOnOusideContainerClickCartPopup: function() {
		Global.$domBody.on('mouseup', function(e) {
			e.preventDefault();
			if (Popups.$domCartPopupPopup.hasClass(Popups.classActive) && !Popups.$domCartPopupInner.is(e.target) && Popups.$domCartPopupInner.has(e.target).length === 0 && !Popups.$domCartPopupCloseIcon.is(e.target)) {
				Popups.closeCartPopup();
			}
		});
	},

	customOrderPopupShow: function() {
		Popups.$domCustomOrderPopupTrigger.on('click', function() {
			Popups.$domBody.addClass(Popups.classPreventScroll);
			Popups.$domCustomOrderPopupPopup.addClass(Popups.classActive);
		});
	},

	closeCustomOrderOnIcon: function() {
		Popups.$domCustomOrderIconClose.on('click', function() {
			Popups.closeCustomOrderPopup();
		});
	},

	closeCustomOrderPopup: function() {
		Popups.$domBody.removeClass(Popups.classPreventScroll);
		Popups.$domCustomOrderPopupPopup.removeClass(Popups.classActive);
	},

	/* @description close menu if click outside container */
	closeMenuOnOusideContainerClickCustomOrder: function() {
		Popups.$domBody.on('mouseup', function(e) {
			e.preventDefault();
			if (Popups.$domCustomOrderPopupPopup.hasClass(Popups.classActive) && !Popups.$domCustomOrderPopupInner.is(e.target) && !$('.custom-order-select-color-dropdown').is(e.target) && Popups.$domCustomOrderPopupInner.has(e.target).length === 0 && !Popups.$domCustomOrderIconClose.is(e.target)) {
				Popups.closeCustomOrderPopup();
			}
		});
	},

	cartRemovePopupShow: function() {
		$(document).on('click', Popups.$domCartRemovePopupTrigger, function(e) {
			$('body').addClass(Popups.classPreventScroll);
			$('.js-cart-remove__popup[data-item-key=' + $(e.target).data('item-key') + ']').addClass(Popups.classActive);
		});
	},

	closeCartRemovePopupOnIcon: function() {
		$(document).on('click', Popups.$domCartRemoveIconClose, function() {
			Popups.closeCartRemovePopup();
		});
	},

	closeCartRemovePopupOnBtn: function() {
		$(document).on('click', Popups.$domCartRemoveBtnClose, function() {
			Popups.closeCartRemovePopup();
		});
	},

	closeCartRemovePopup: function() {
		$('body').removeClass(Popups.classPreventScroll);
		$(Popups.$domCartRemovePopupPopup).removeClass(Popups.classActive);
	},

	/* @description close menu if click outside container */
	closeMenuOnOusideContainerClickCartRemovePopup: function() {
		$(document).on('mouseup', 'body', function(e) {
			e.preventDefault();
			if ($(Popups.$domCartRemovePopupPopup).hasClass(Popups.classActive) && !$(Popups.$domCartRemovePopupInner).is(e.target) && $(Popups.$domCartRemovePopupInner).has(e.target).length === 0 && !$(Popups.$domCartRemoveIconClose).is(e.target)) {
				Popups.closeCartRemovePopup();
			}
		});
	},

	openOrderCancelPopup: function() {
		Popups.$domOrderCancelButton.on('click', function(e) {
			const orderID = $(e.target).data('order-id');
			$(`.js-my-account__order-cancel-popup[data-order-id="${orderID}"]`).addClass(Popups.classActive);
		});
	},

	closeOrderCancelPopup: function() {
		Popups.$domOrderCancelPopupPopup.removeClass(Popups.classActive);
		Popups.$domBody.removeClass(Popups.classPreventScrollAlt);
	},

	closeOrderCancelPopupIcon: function() {
		Popups.$domOrderCancelCloseIcon.on('click', function() {
			Popups.closeOrderCancelPopup();
		});
	},

	closeOrderCancelPopupBtn: function() {
		Popups.$domOrderCancelCloseBtn.on('click', function() {
			Popups.closeOrderCancelPopup();
		});
	},

	closeMenuOnOusideContainerClickOrderCancelPopup: function() {
		Global.$domBody.on('mouseup', function(e) {
			e.preventDefault();
			if (Popups.$domOrderCancelPopupPopup.hasClass(Popups.classActive) && !Popups.$domOrderCancelPopupInner.is(e.target) && Popups.$domOrderCancelPopupInner.has(e.target).length === 0 && !Popups.$domOrderCancelCloseIcon.is(e.target)) {
				Popups.closeOrderCancelPopup();
			}
		});
	},

	addressRemovePopupShow: function() {
		Popups.$domAddressRemovePopupTrigger.off('click');
		Popups.$domAddressRemovePopupTrigger.on('click', function(e) {
			const addressInfo = $(e.target).closest('.wc-address-book-address').find('address').html();
			const addressType = $(e.target).closest('.address_book').find('header').find('h3').text();
			const addressID = $(e.target).attr('id');
			Popups.$domAddressRemovePopupPopup.find('.js-address-info').html(addressInfo);
			Popups.$domAddressRemovePopupPopup.find('.js-address-title').text(addressType);
			Popups.$domAddressRemovePopupPopup.find('.js-remove-address').attr('id', addressID);
			Popups.$domBody.addClass(Popups.classPreventScroll);
			Popups.$domAddressRemovePopupPopup.addClass(Popups.classActive);
		});
	},

	closeAddressRemovePopupOnIcon: function() {
		Popups.$domAddressRemoveIconClose.on('click', function() {
			Popups.closeAddressRemovePopup();
		});
	},

	closeAddressRemovePopupOnBtn: function() {
		Popups.$domAddressRemoveBtnClose.on('click', function() {
			Popups.closeAddressRemovePopup();
		});
	},

	closeAddressRemovePopup: function() {
		Popups.$domBody.removeClass(Popups.classPreventScroll);
		Popups.$domAddressRemovePopupPopup.removeClass(Popups.classActive);
	},

	/* @description close menu if click outside container */
	closeMenuOnOusideContainerClickAddressRemovePopup: function() {
		Popups.$domBody.on('mouseup', function(e) {
			e.preventDefault();
			if (Popups.$domAddressRemovePopupPopup.hasClass(Popups.classActive) && !Popups.$domAddressRemovePopupInner.is(e.target) && Popups.$domAddressRemovePopupInner.has(e.target).length === 0 && !Popups.$domAddressRemoveIconClose.is(e.target)) {
				Popups.closeAddressRemovePopup();
			}
		});
	},

	closePaymentRemovePopupOnIcon: function() {
		Popups.$domPaymentRemoveIconClose.on('click', function() {
			Popups.closePaymentRemovePopup();
		});
	},

	closePaymentRemovePopupOnBtn: function() {
		Popups.$domPaymentRemoveBtnClose.on('click', function() {
			Popups.closePaymentRemovePopup();
		});
	},

	openPaymentRemovePopup: function() {
		Popups.$domPaymentRemoveTrigger.on('click', function(e) {
			$(`.js-my-account__payments-remove-popup[data-payment="${$(e.target).data('payment')}"]`).addClass(Popups.classActive);
		});
	},

	closePaymentRemovePopup: function() {
		Popups.$domBody.removeClass(Popups.classPreventScroll);
		Popups.$domPaymentRemovePopupPopup.removeClass(Popups.classActive);
	},

	/* @description close menu if click outside container */
	closeMenuOnOusideContainerClickPaymentRemovePopup: function() {
		Popups.$domBody.on('mouseup', function(e) {
			e.preventDefault();
			if (Popups.$domPaymentRemovePopupPopup.hasClass(Popups.classActive) && !Popups.$domPaymentRemovePopupInner.is(e.target) && Popups.$domPaymentRemovePopupInner.has(e.target).length === 0 && !Popups.$domPaymentRemoveIconClose.is(e.target)) {
				Popups.closePaymentRemovePopup();
			}
		});
	},

	popupNewYearPromoCode: function() {
		const copyButton = $('#js-promotion-block__promo-code-btn');
		const promoCode = $('.js-promotion-block__promo-code-text').text();
		copyButton.on('click', function() {
			navigator.clipboard.writeText(promoCode);
			$('.js-promotion-block__promo-code-tooltip').addClass('is-visible');
			setTimeout(function(){
				$('.js-promotion-block__promo-code-tooltip').removeClass('is-visible');
			}, 2000);
		});
	},

	// openPopupNewYearPromoCode: function() {
	// 	$(document).ready(function() {
	// 		if ((sessionStorage.getItem('popupDisplayed') !== 'true')) {
	// 			Popups.$domBody.addClass(Popups.classPreventScroll);
	// 			Popups.$domNewYearPromoCodePopup.addClass(Popups.classActive);
	// 			sessionStorage.setItem('popupDisplayed', 'true');
	// 		}
	// 	});
	// },

	// closepopupNewYearPromoCodeOnIcon: function() {
	// 	Popups.$domNewYearPromoCodeIconClose.on('click', function() {
	// 		Popups.closepopupNewYearPromoCode();
	// 	});
	// },

	// closepopupNewYearPromoCode: function() {
	// 	Popups.$domBody.removeClass(Popups.classPreventScroll);
	// 	Popups.$domNewYearPromoCodePopup.removeClass(Popups.classActive);
	// },

	// /* @description close menu if click outside container */
	// closeMenuOnOusideContainerClickPopupNewYearPromoCode: function() {
	// 	Popups.$domBody.on('mouseup', function(e) {
	// 		e.preventDefault();
	// 		if (Popups.$domNewYearPromoCodePopup.hasClass(Popups.classActive) && !Popups.$domNewYearPromoCodePopupInner.is(e.target) && Popups.$domNewYearPromoCodePopupInner.has(e.target).length === 0 && !Popups.$domNewYearPromoCodeIconClose.is(e.target)) {
	// 			Popups.closepopupNewYearPromoCode();
	// 		}
	// 	});
	// },
};

export default Popups;
